import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import variableStyles from '../../styles/variables.module.css.js';

const Variant6PathwayIllustration = /*#__PURE__*/ forwardRef(({ color = variableStyles.black, width = '100%' }, ref)=>jsx("svg", {
        width: width,
        viewBox: "0 0 902 960",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: jsx("path", {
            ref: ref,
            d: "M70.334 280.776C184.391 146.169 359.072 55.299 534.647 72.5884C576.329 76.6985 618.86 87.376 651.607 113.556C684.354 139.736 704.95 184.098 693.736 224.44C681.227 269.518 633.871 296.949 587.676 304.186C541.482 311.424 494.394 303.427 447.619 302.935C400.843 302.444 350.405 311.245 317.747 344.752C285.044 378.348 278.03 433.566 299.564 475.249C321.098 516.931 368.677 542.977 415.542 540.788C472.503 538.107 520.976 498.837 576.15 484.407C654.109 464.035 741.807 498.659 789.61 563.528C864.218 664.718 826.11 785.029 780.541 889.033",
            stroke: color,
            strokeWidth: "140",
            strokeMiterlimit: "10",
            strokeLinecap: "round"
        })
    }));

export { Variant6PathwayIllustration as default };
